// Lightweight scroll-reveal: adds .is-revealed to [data-reveal] elements as they enter the viewport.
// Respects prefers-reduced-motion by doing nothing (elements are only hidden via CSS when motion is allowed).
(function () {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-revealed');
          observer.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.15, rootMargin: '0px 0px -8% 0px' }
  );

  function observeAll() {
    document.querySelectorAll('[data-reveal]:not(.is-revealed)').forEach(function (el) {
      observer.observe(el);
    });
    document
      .querySelectorAll(
        '#shopify-section-product_list_YidTcf .resource-list__item:not(.is-revealed), ' +
          '#shopify-section-product_list_DMCahf .resource-list__item:not(.is-revealed)'
      )
      .forEach(function (el) {
        observer.observe(el);
      });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', observeAll);
  } else {
    observeAll();
  }

  // Re-scan when Shopify section editor re-renders a section (theme editor live preview).
  document.addEventListener('shopify:section:load', observeAll);
})();
